import React, {useEffect, useState} from 'react';
import Stack from "@mui/material/Stack";
import Html5QrcodePlugin from "./QrCustomComponent";
import Button from "@mui/material/Button";
import {enums} from "../../utils/enums";
import sound from './confirm.mp3'
import triangles from './triangles.svg'
import Typography from "@mui/material/Typography";
import {auth} from "../../utils/firebaseApp";
import {Header} from "../../shared-components/Header";

const TicketScanner = () => {
    console.log(auth.currentUser)
    const [qrCodeResult, setQrCodeResult] = useState(null);
    const [desiredScannerState, setDesiredScannerState] = useState(null);
    const [isScanning, setIsScanning] = useState(false);
    let chime = new Audio(sound);
    chime.loop = false

    useEffect(() => {
        try {
            //TODO: make a db call to invalidate the ticket
            if (!qrCodeResult) return
            chime.load()
            chime.play()
            setQrCodeResult(null)
        } catch (e) {
            console.log(e)
        }
    }, [qrCodeResult])


    return (
        <>
            <Header/>
            <Stack direction={'column'} alignItems={'center'}
                   sx={{minHeight: '100vh', backgroundImage: `url(${triangles})`, backgroundSize: 'cover'}}>
                <Typography variant={'h1'} sx={{color: 'white', margin: 5}}><strong>BeeTix Scanner</strong></Typography>
                <Html5QrcodePlugin
                    disableFlip={false}
                    fps={10}
                    qrbox={250}
                    aspectRatio={1}
                    videoConstraints={{facingMode: "environment"}}

                    setIsScanning={setIsScanning}
                    isScanning={isScanning}
                    qrCodeResult={qrCodeResult}
                    setQrCodeResult={setQrCodeResult}
                    desiredScannerState={desiredScannerState}
                />

                {qrCodeResult && <Button varaint={'contained'}
                                         sx={{
                                             backgroundColor: 'white',
                                             color: 'black',
                                             margin: 5
                                         }} onClick={() => {
                    setDesiredScannerState(enums.RESUME)
                    setQrCodeResult(null)
                }}>Next</Button>}
            </Stack>
        </>
    )
};

export default TicketScanner;
